import React, { useState } from 'react';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { AssessmentContent } from './components/AssessmentContent';
import { BottomNavigation } from './components/BottomNavigation';
export function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAssessmentComplete, setIsAssessmentComplete] = useState(false);
  const [isOnResultsScreen, setIsOnResultsScreen] = useState(false);
  const handleAssessmentStatusChange = (isComplete, isResults = false) => {
    setIsAssessmentComplete(isComplete);
    setIsOnResultsScreen(isResults);
  };
  return <div className="flex justify-center w-full min-h-screen bg-gray-50" data-id="element-0">
      <div className="w-full max-w-[1440px]" data-id="element-1">
        <Header onOpenSidebar={() => setIsSidebarOpen(true)} data-id="element-2" />
        <div className="flex flex-1 relative" data-id="element-3">
          <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} isAssessmentComplete={isAssessmentComplete} isOnResultsScreen={isOnResultsScreen} data-id="element-4" />
          <AssessmentContent onAssessmentStatusChange={handleAssessmentStatusChange} onOpenSidebar={() => setIsSidebarOpen(true)} data-id="element-5" />
        </div>
        <BottomNavigation data-id="element-6" />
      </div>
    </div>;
}